import { Toaster } from 'sonner'

/**
 * The app's toast layer — one element, mounted once at the root.
 *
 * It exists as a component rather than as JSX inline in `__root.tsx` because
 * its wrapper is load-bearing and belongs next to the thing that reads it:
 * `sonner` renders in place rather than through a portal, so this `div` is
 * what lands as the toast layer's own `document.body` child (RootDocument
 * renders its children straight into `<body>`), and `data-modal-inert-exempt`
 * is how `src/ui/Modal.tsx` knows to leave it alone when it marks the rest of
 * the page `inert`. Dialogs report their own save failures through toasts, and
 * host sections that raise their own — an inerted toast is an unclickable,
 * unannounced one, at exactly the moment it fires.
 */
export function ToastLayer() {
  return (
    <div data-modal-inert-exempt>
      <Toaster />
    </div>
  )
}
